import Base64 from 'compact-base64';

export default function decodeObject(encoded) {
  const text = Base64.decode(encoded);
  return JSON.parse(text);
}
